import { createSlice, current } from "@reduxjs/toolkit";

export const contactListSlice = createSlice({
  name: "contactList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedContact: null,
    filteredRecords: 0,
    isSingleContactLoading: false,
    isLoading: false,
    isAnswerByTechTeam: false,
  },
  reducers: {
    setAllContactLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleContactLoadingState: (state, action) => {
      state.isSingleContactLoading = true;
    },
    loadAllContact: (state, action) => {
      const listObj = {};
      action.payload.contacts.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.contacts.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleContact: (state, action) => {
      state.selectedContact =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleContactLoading = false;
    },
    updateContact: (state, action) => {
      const { id, status } = action.payload;
      console.log("state", current(state));

      state.byId[id].isPlatfrom = status;

      if (current(state)?.selectedContact?.id === id) {
        state.selectedContact.isPlatfrom = status;
      }
    },
  },
});

export const {
  setAllContactLoadingState,
  setSingleContactLoadingState,
  loadAllContact,
  loadSingleContact,
  updateContact,
} = contactListSlice.actions;

export default contactListSlice.reducer;
